import Base from "./base";

class DealerCodesResource extends Base {
  path = "/v2/admin/dealer-codes";

  getAll = async (query) => {
    const res = await this.getRequest(this.path, query);
    const data = res?.data || [];
    return { data, total: data.length };
  };

  getById = async (id) => {
    const res = await this.getRequest(`${this.path}/${id}`);
    return res?.data || res;
  };

  create = (data) => this.postRequest(this.path, data);

  update = (data) => this.putRequest(`${this.path}/${data.id}`, data);

  updateStatus = (id, isActive) =>
    this.putRequest(`${this.path}/${id}/status`, { is_active: isActive });

  delete = (id) => this.deleteRequest(`${this.path}/${id}`);
}

export default new DealerCodesResource();
